"use client";

import { ArrowTopRightOnSquareIcon } from "@heroicons/react/20/solid";
import { Bars3Icon } from "@heroicons/react/24/outline";
import { useState } from "react";

import { MobileMenuDialog } from "@/components/headerMarketing/MobileMenuDialog";
import { TextLink } from "@/components/links/TextLink";
import { LogoLink } from "@/components/LogoLink";
import { Badge } from "@/components/text/Badge";
import { navigationMarketing } from "@/constants/navigation";

export function Menu({ actionButton }: { actionButton: React.ReactNode }) {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  return (
    <>
      <nav
        className="mx-auto flex max-w-7xl items-center justify-between gap-x-6 p-4 lg:px-8"
        aria-label="Global"
      >
        <div className="flex lg:flex-1">
          <LogoLink className="-m-1.5 p-1.5" />
        </div>
        <div className="hidden lg:flex lg:gap-x-12">
          {navigationMarketing.map((navItem) => (
            <div key={navItem.name} className="relative">
              {navItem.label !== null && (
                <Badge className="absolute -top-4 left-4 whitespace-nowrap bg-primaryLight px-1 py-0.5 text-gray-900 shadow-md">
                  {navItem.label}
                </Badge>
              )}
              <TextLink
                className="flex items-center gap-1"
                href={navItem.href}
                external={navItem.external}
              >
                {navItem.name}
                {navItem.external && (
                  <ArrowTopRightOnSquareIcon className="h-[14px] w-[14px] text-inherit" />
                )}
              </TextLink>
            </div>
          ))}
        </div>
        <div className="flex flex-1 items-center justify-end">
          {actionButton}
        </div>
        <div className="flex lg:hidden">
          <button
            type="button"
            className="-m-2.5 inline-flex items-center justify-center rounded-md p-2.5 text-gray-700"
            onClick={() => setMobileMenuOpen(true)}
          >
            <span className="sr-only">Open main menu</span>
            <Bars3Icon className="h-6 w-6" aria-hidden="true" />
          </button>
        </div>
      </nav>
      <MobileMenuDialog
        mobileMenuOpen={mobileMenuOpen}
        setMobileMenuOpen={setMobileMenuOpen}
        actionButton={actionButton}
      />
    </>
  );
}
